export function localStorageFunc(type, data, key) {
  if (type === 'save') {
    localStorage.setItem(key, data);
  } else if (type === 'get') {
    return localStorage.getItem(key);
  } else if (type === 'remove') {
    localStorage.removeItem(key);
  }
}
